import { parsePhoneNumberFromString } from 'libphonenumber-js';

/** ISO country from E.164 (distinguishes US vs CA for +1). */
export const getPhoneCountry = (phone?: string | null): string | undefined => {
  if (!phone) return undefined;
  const normalized = String(phone).replace(/\s+/g, '');
  if (!normalized) return undefined;
  return parsePhoneNumberFromString(normalized)?.country;
};

/** True only for United States numbers — not Canada (both use +1). */
export const isUsPhoneNumber = (phone?: string | null): boolean => getPhoneCountry(phone) === 'US';
